import React, { useState } from "react";
import styles from "./styles/styles.module.scss";
import BlogCard from "./BlogCard";
import { Container, Row, Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const Index = ({ data }) => {
  const { blogsData } = data;

  const [visibleBlogs, setVisibleBlogs] = useState(8);

  const renderBlogs = () => {
    if (blogsData?.length > 0) {
      return blogsData
        .slice(0, visibleBlogs)
        .map((item, index) => (
          <BlogCard blog={item} key={index} index={index} />
        ));
    }
    return null;
  };

  const showMoreBlogs = () => {
    setVisibleBlogs((prev) => prev + 8);
  };

  return (
    <div className={styles.blogs}>
      <Container>
        <Row>{renderBlogs()}</Row>
        {visibleBlogs < blogsData.length && (
          <div className="view-all">
            <Button className="nav-link" onClick={showMoreBlogs}>
              <FormattedMessage id="show-more" />
            </Button>
          </div>
        )}
      </Container>
    </div>
  );
};

export default Index;
